﻿/**
 * Carousel - A plugin to manage the integratio of the Slick Carousel into MVC Views.
 *
 * @class rlCarousel
 * @memberOf jQuery.fn
 */

(function($) {
    $.fn.rlSetupCarousels = function() {

        $(function() {
            SliderSlick();
            DynamicSliderSlick();
            ComparisonSlick();
        });

        // On before slide change
        $('.dynamicsliderblock .slider-container, .sliderblock .slider-container').on('init', function () {
           const slideID = $(this).attr('id');
           tabindexminustab('#' + slideID + ' .teaserctatext');          
        });
        $('.dynamicsliderblock .slider-container, .sliderblock .slider-container').on('afterChange', function () {
          const slideID = $(this).attr('id');
          tabindexminustab('#' + slideID + ' .teaserctatext');
        });
        // set tabindex to ignore
        function tabindexminustab(selector) {
           setTimeout(function () {
              $(selector).attr('tabindex', '-1');
           }, 250);
        }
        //place right nav next button
       function placerightbutton(blockName, sliderContainerName, navName) {
           setTimeout(function () {
              $(blockName + ' .slider-container').each(function (key) {
                 var sliderItem = $('#' + sliderContainerName + key);                 
                 var leftButton = $('#' + navName + key + 'top' + '>.cta-button-arrow--left');
                 var rightButton = $('#' + navName + key + 'bot' + '>.cta-button-arrow--right');                 
                 rightButton.css('top', -(sliderItem.outerHeight() + leftButton.outerHeight()));
              });
           }, 250);
           
        }

        var rlSliderButton;
        rlSliderButton = (function () {
          let stateCheck = setInterval(() => {
             if (document.readyState === 'complete') {
                clearInterval(stateCheck);
                elem = document.getElementById("main-content");
                let resizeObserver = new ResizeObserver(() => {
                   placerightbutton('.sliderblock', 'sliderContainer', 'sliderNav');
                   placerightbutton('.dynamicsliderblock', 'dynamicsliderContainer', 'dynamicsliderNav');
                });
                resizeObserver.observe(elem);
             }
          }, 250);
        });

        rlSliderButton();
        placerightbutton('.sliderblock', 'sliderContainer', 'sliderNav');
        placerightbutton('.dynamicsliderblock', 'dynamicsliderContainer', 'dynamicsliderNav');

       function SliderSlick() {
          initializeAndSetupSlider('.sliderblock', 'sliderBlock', 'sliderContainer', 'sliderNav');
       }
       function DynamicSliderSlick() {
          initializeAndSetupSlider('.dynamicsliderblock', 'dynamicsliderBlock', 'dynamicsliderContainer', 'dynamicsliderNav'); 
       }


       //Used to refresh slick css components when resize/page zoom/font enlarge occurs.
       var rlReFreshSlider;
       rlReFreshSlider = (function () {
          let stateCheck = setInterval(() => {
             if (document.readyState === 'complete') {
                clearInterval(stateCheck);

                elem = document.getElementById("main-content");
                let resizeObserver = new ResizeObserver(() => {
                   $('.slick-slider').slick('refresh');
                });
                resizeObserver.observe(elem);
             }
          }, 250);
       });
       rlReFreshSlider();
        

        //Comparison block slider
        function compHeaderHeight() {
            //reset header heights

            $('.comp-col .comp-item.heading').height('auto');
            //Comparison table find/store and match height of headings on mob
            var headingHeights = $('.comp-col .comp-item.heading').map(function() {
                return $(this).height();
            }).get();

            var maxHeight = Math.max.apply(null, headingHeights);
            //set max height
            $('.comp-col .comp-item.heading').height(maxHeight);
        }

        function ComparisonSlick() {

            if ($('.comparisoncontainerblock').length > 0) {

                $('.comp-slider').each(function(key) {

                    var CompSliderIdName = 'CompSlider' + key;
                    var CompSliderNavIdName = 'sliderNav' + key;

                    this.id = CompSliderIdName;
                    $('.slider-controls')[key].id = CompSliderNavIdName;

                    var CompSliderId = '#' + CompSliderIdName;

                    //Comparison table slider
                    $(CompSliderId).slick({
                        prevArrow: '#' + CompSliderNavIdName + '>.cta-button-arrow--left',
                        nextArrow: '#' + CompSliderNavIdName + '>.cta-button-arrow--right',
                        infinite: true,
                        speed: 300,
                        accessibility: true,
                        autoplay: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                        dots: true,
                        customPaging: function(slider, i) {
                            return '<a></a>';
                        }
                    });

                });

                //set header heights on resize
                $(window).on('resize-end', function() {
                    compHeaderHeight();
                });
                compHeaderHeight();
            }
       }
       function initializeAndSetupSlider(containerClass, blockName, containerName, navName) {
          $(containerClass + ' .slider-container').each(function (key) {
             
             var blockIdName = blockName + key;
             var sliderIdName = containerName + key;
             var sliderNavIdNameTop = navName + key + 'top';
             var sliderNavIdNameBot = navName + key + 'bot';

             this.id = sliderIdName;
             $(this).parents(containerClass).attr('id', blockIdName);
             $('#' + blockIdName + ' .custom-slick-nav.top').attr('id', sliderNavIdNameTop);
             $('#' + blockIdName + ' .custom-slick-nav.bot').attr('id', sliderNavIdNameBot);

             var sliderId = '#' + sliderIdName;
             var leftArrowButton = '#' + sliderNavIdNameTop + '>.cta-button-arrow--left';
             var rightArrowButton = '#' + sliderNavIdNameBot + '>.cta-button-arrow--right';

             OnSlickEvent(sliderId, leftArrowButton, rightArrowButton);
          });
       }

       function OnSlickEvent(sliderId, prevArrowButton, nextArrowButton) {
          $(sliderId).slick({
             prevArrow: prevArrowButton,
             nextArrow: nextArrowButton,
             infinite: false,
             speed: 300,
             accessibility: true,
             autoplay: false,
             slidesToShow: 3,
             slidesToScroll: 3,
             centerMode: false,
             lazyLoad: 'anticipated',
             responsive: [{
                breakpoint: 993,
                settings: {
                   slidesToShow: 3,
                   slidesToScroll: 3
                }
             },
             {
                breakpoint: 769,
                settings: {
                   slidesToShow: 2,
                   slidesToScroll: 2
                }
             },
             {
                breakpoint: 577,
                settings: {
                   arrows: false,
                   slidesToShow: 1,
                   slidesToScroll: 1
                }
             }
             ]
          });
       }
    }
}(jQuery));